<template>
    <div v-if="is_settings_admin" class="uk-container uk-container-center uk-margin-large-top">
        <ul class="uk-tab uk-text-large">
            <li :class="{'uk-active': (current_page_id === 'settings')}">
                <a href @click.prevent="maybe_change_current_page('settings')">
                    Settings
                </a>
            </li>
            <li :class="{'uk-active': (current_page_id === 'lists')}">
                <a href @click.prevent="maybe_change_current_page('lists')">
                    Dictionaries, Lists &amp; Keywords
                </a>
            </li>
            <li :class="{'uk-active': (current_page_id === 'templates')}">
                <a href @click.prevent="maybe_change_current_page('templates')">
                    Phase Templates
                </a>
            </li>
        </ul>
        <ul id="settings-pages" class="uk-switcher uk-margin">
            <keep-alive>
                <settings
                    v-if="(current_page_id === 'settings')"
                    class="uk-active"
                />

                <lists
                    v-if="(current_page_id === 'lists')"
                    class="uk-active"
                />

                <templates
                    v-if="(current_page_id === 'templates')"
                    class="uk-active"
                />
            </keep-alive>
        </ul>
    </div>
</template>

<script type="text/javascript">
/*
import { mapGetters } from 'vuex'
import { orderBy, findIndex } from 'lodash'
import utilities from '../../mixins/Is'
import notifies from '../../mixins/Notifies'
import confirms from '../../mixins/Confirms'

import AutoSaveInput from '../../ui/AutoSaveInput'
import AutoSaveSelect from '../../ui/AutoSaveSelect'
import AutoSaveDateRange from '../../ui/AutoSaveDateRange'
import AutoSaveRadioButtons from '../../ui/AutoSaveRadioButtons'
import FileUploadForm from '../../ui/FileUploadForm'
import PhaseTemplates from '../../ui/PhaseTemplates'
import OpenIcon from '../../ui/OpenIcon'
*/
import profile_utilities from "../../mixins/ProfileUtilities"

import Settings from "./Settings"
import Lists from "./Lists"
import Templates from "./Templates"

export default {
    mixins: [profile_utilities],
    components: {
        Settings,
        Lists,
        Templates
    },
    mounted () {
        this.load_data()
    },
    watch: {
        $route: "load_data",
        profile_id: "load_data"
    },
    methods: {
        load_data () {
            if(this.is_settings_admin) this.$store.dispatch("FETCH_RECORDS", { entity: "user" })
        },
        change_current_page (page_id) {
            this.current_page_id = page_id
        },
        maybe_change_current_page (page_id) {
            if(this.current_page_id !== page_id) this.change_current_page(page_id)
        }
    },
    data () {
        return {
            current_page_id: "settings"
        }
    }
    /*
    components: {
        AutoSaveInput,
        AutoSaveSelect,
        AutoSaveDateRange,
        AutoSaveRadioButtons,
        FileUploadForm,
        PhaseTemplates,
        OpenIcon
    },
    mixins: [utilities, notifies, confirms],
    methods: {

        dictionary_dont_edit () {
            this.edited_dictionary = {}
        },
        dictionary_terms (dictionary_id) {
            return this.terms.filter((term) => {
                return term.dictionary_id===dictionary_id
            })
        },
        dictionary_term_default (term) {
            this.$store.dispatch('RECORD_SAVE', {
                entity: "term",
                id: term.id,
                data: {default_value: !term.default_value}
            }).then(response => {
                if(response) this.$error(response.message)
            }).catch(error => {
                if(error) this.$error(error.message)
            })
        },

        service_edit (service_index) {
            this.edited_service_index = service_index;
        },
        service_dont_edit () {
            this.edited_service_index = -1
        },
        service_choices_save (choices) {
            this.$store.dispatch('RECORD_SAVE', {
                entity: "service",
                id: this.edited_service.id,
                data: {description: JSON.stringify(choices)}
            }).then(response => {
                if(response) this.$error(response.message)
                else this.new_service_choice = ""
            }).catch(error => {
                if(error) this.$error(error.message)
            })
        },
        service_choice_set (index, event) {
            let choices = this.edited_service_choices
            choices[index] = event.target.value
            this.service_choices_save(choices)
        },
        service_choice_remove (index) {
            let choices = this.edited_service_choices
            choices.splice(index, 1)
            this.service_choices_save(choices)
        },

        new_holiday_update (field, value) {
            this.new_holiday[field] = value
        },
        holiday_add () {
            if(!this.new_holiday.name || !this.new_holiday.starts_at || !this.new_holiday.ends_at) {
                this.$error("Please complete the entry first!")
            } else {
                this.settings.holidays.push(this.new_holiday)
                this.holiday_update(-1)
            }
        },
        keyword_section_edit (keyword_section) {
            this.new_keyword.section = keyword_section
            this.new_keyword.name = ""
            this.edited_keyword_section = keyword_section
        },
        keyword_section_dont_edit () {
            this.edited_keyword_section = ""
        },
        keyword_section_add () {
            this.keyword_section_edit(this.new_keyword_section)
            this.new_keyword_section = ""
        },
        keyword_section_change (event) {
            const edited_keyword_section_keywords = this.edited_keyword_section_keywords
            if(!edited_keyword_section_keywords.length) this.edited_keyword_section = event.target.value
            else {
                this.$store.dispatch('RECORD_SAVE', {
                    entity: "category",
                    id: edited_keyword_section_keywords[0].id,
                    data: { section: event.target.value }
                }).then(response => {
                    if(response) {
                        this.$error(response.message)
                        event.target.value = this.edited_keyword_section
                    } else this.edited_keyword_section = event.target.value
                }).catch(error => {
                    if(error) this.$error(error.message)
                })
            }
        },
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_studio_records () {
            return this.entity_records("studio")
        },
        studios () {
            return this.raw_studio_records
        },
        raw_category_records () {
            return this.entity_records("category")
        },
        ...mapGetters({
            settings: 'settings',
            all_dictionaries: 'dictionary_records',
            services: 'service_records',
            terms: 'term_records',
            user: 'user_records',
        }),
        sorted_dictionaries () {
            return orderBy(this.all_dictionaries.filter(dictionary => !dictionary.autosuggest), [dictionary => dictionary.name], "asc")
        },
        sorted_autosuggests () {
            return orderBy(this.all_dictionaries.filter(dictionary => !!dictionary.autosuggest), [dictionary => dictionary.name], "asc")
        },
        sorted_services () {
            return orderBy(this.services, [service => service.name], "asc")
        },
        edited_service () {
            if(this.edited_service_index < 0) return {}
            return this.sorted_services[this.edited_service_index]
        },
        edited_service_choices () {
            if(!this.edited_service || (this.edited_service.description_type !== "list")) return null
            const choices = JSON.parse(this.edited_service.description) || []
            return choices
        },

        current_year () {
            return this.$moment().format("YYYY")
        },
        weekdays () {
            return [
                { id: 1, label: "Mon" },
                { id: 2, label: "Tue" },
                { id: 3, label: "Wed" },
                { id: 4, label: "Thu" },
                { id: 5, label: "Fri" },
                { id: 6, label: "Sat" },
                { id: 7, label: "Sun" },
            ]
        },
    },
    data() {
        return {
            edited_dictionary: {},
            new_term: {name: "", weight: ""},
            new_service: "",
            edited_service_index: -1,
            new_service_choice: "",
            new_holiday: {id: "", name: "", starts_at: "", ends_at: ""},
            new_keyword_section: "",
            edited_keyword_section: "",
            new_keyword: {section: "", name: ""},
        }
    }
    */
}
</script>
